export function SkilloLogo({ variant = 'academy', height = 32, theme = 'dark' }: { variant?: 'primary' | 'academy' | 'store'; height?: number; theme?: 'dark' | 'light' }) {
  if (theme === 'light') {
    return (
      <img
        src="/images/logo-720.png"
        alt={`Skillo${variant === 'academy' ? ' Academy' : variant === 'store' ? ' Store' : ''}`}
        height={height}
        style={{ height }}
        className="w-auto"
      />
    )
  }
  const iconSize = height * 0.9
  const fontSize = height * 0.55

  return (
    <span className="inline-flex items-center gap-2">
      <img
        src="/images/logo-icon-256.png"
        alt=""
        height={iconSize}
        width={iconSize}
        style={{ height: iconSize, width: iconSize }}
        className="object-contain"
      />
      <span
        className="font-display font-bold text-white leading-none"
        style={{ fontSize: `${fontSize}px`, letterSpacing: '-0.03em' }}
      >
        Skillo
      </span>
    </span>
  )
}
